import { render, staticRenderFns } from "./campPromotePlayer.vue?vue&type=template&id=11492422&scoped=true&"
import script from "./campPromotePlayer.vue?vue&type=script&lang=js&"
export * from "./campPromotePlayer.vue?vue&type=script&lang=js&"
import style0 from "./campPromotePlayer.vue?vue&type=style&index=0&id=11492422&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11492422",
  null
  
)

export default component.exports